module.exports = __webpack_public_path__ + "img/termosAdesaoFill.575453dd.svg";